export default [
  {
    "label": "",
    "sublabel": "",
    "value": ""
  },
  {
    "label": "AAMS   Agency Asset Management System.",
    "sublabel": "To provide enterprise lifecycle asset management control and accountability of EPA's personal property assets in accordance with Federal Management Regulations.",
    "value": "020-000030304"
  },
  {
    "label": "AAW - AutoAudit for Windows",
    "sublabel": "AutoAudit for Windows is the primary auditing management system used within the Office of Inspector General (OIG).  It is used for tracking and managing: auditing, recommendation, reporting, and executive dashboard information.",
    "value": "020-000000080"
  },
  {
    "label": "ACRES- Assessment Cleanup and Redevelopment Exchange System",
    "sublabel": "The ACRES database tracks environmental information from brownfields properties receiving EPA grant funding. Information reported includes the type of property work, status of environmental assessment and cleanup activities, and the presence and remediation of contaminants.",
    "value": "020-000014012"
  },
  {
    "label": "AIRNOW",
    "sublabel": "Real-time air quality data for 50 states and air quality forecasts for over 400 cities collected and distributed to the public and national media.  Data delivered from state and local agencies and merged for presentation on the EPA AirNow website.",
    "value": "020-000011072"
  },
  {
    "label": "AITSP - Agency IT Security and Privacy Program",
    "sublabel": "The AITSP investment enables agency-wide implementation, management and oversight of the CIO s Information Security and Privacy Programs.  The EPA sole agency SOC covers the entire enterprise and is managed & operated by the CISO Office (OISP)  which is reflected in the AITSP Standard Report. Work in this program directly supports Goal 3/Objective 3.5, Improve Efficiency and Effectiveness in the FY2018-2022 EPA Strategic Plan.",
    "value": "020-000016040"
  },
  {
    "label": "AQS DataMart",
    "sublabel": "Provides external access to the ambient air quality measurements collected by EPA.",
    "value": "020-000011081"
  },
  {
    "label": "AQS- Air Quality System",
    "sublabel": "Contains ambient air quality measurements of criteria and toxic air pollutants and descriptive information about the locations where the ambient air quality data are collected.",
    "value": "020-000011020"
  },
  {
    "label": "ARadDS - Analytical Radiation Data System",
    "sublabel": "ARadDS is the IT architecture that supports radiation monitoring data collected and analyzed from RadNet, fixed and mobile laboratories and the Radon Program.  ARadDS is designated as a HVA and CIKR system. The system operates continuously and is hosted at the National Analytical Radiation Environmental Laboratory and maintains radiation data for the nation's air, precipitation, drinking water, and soil. This system fulfills EPA national radiation monitoring responsibilities. Stakeholders include the public, tribal and other government organizations along with international organizations. The IT scope includes all architecture, end points, communications, analytics with embedded computer and software and hosted software.  The investment also covers all security IT components including physical security/access, CDM, and facility computer systems hosted on the architecture.  The system scope also includes hosting, contracts (or portion of), and personnel costs related to IT management.",
    "value": "020-000011060"
  },
  {
    "label": "Administrators Mission Investment",
    "sublabel": "Collection of IT Investments each less than $250K per year supporting EPA's Office of the Administrator.",
    "value": "020-000000095"
  },
  {
    "label": "Air Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's National Air Program.",
    "value": "020-000000086"
  },
  {
    "label": "BFS - Budget Formulation System",
    "sublabel": "Budget Formulation System (BFS) formerly titled New Budget Formulation System (NBFS) is EPA's one stop shop combining budget formulation, budget execution, reporting, and performance into a single web application.",
    "value": "020-000010070"
  },
  {
    "label": "CAMDBS - Clean Air Markets Division Business System",
    "sublabel": "The CAMD Business Systems (CAMDBS) are an Internet-based portal that supports the operation of the emissions trading programs implemented by EPA.  These programs the Acid Rain Program and the Cross-State Air Pollution Rule require electric utilities to report their hourly emissions to EPA, and facilitates allowance trading to cover their annual or seasonal emissions.",
    "value": "020-000011030"
  },
  {
    "label": "CAMEO - Computer Aided Management of Emergency Operations",
    "sublabel": "CAMEO is a system of software applications used widely to plan for and respond to chemical emergencies. It is used by LEPCs/TEPCs and emergency responders to maintain inventory of hazardous chemicals in their communities and model chemical events.",
    "value": "020-000014010"
  },
  {
    "label": "CCD - CompTox Chemicals Dashboard",
    "sublabel": "The CompTox Chemicals Dashboard is an online tool that integrates available chemical information including physicochemical properties, environmental fate and transport, exposure, usage, in vivo toxicity and in vitro bioassays.",
    "value": "020-000000079"
  },
  {
    "label": "CCRS - Criminal Case Reporting System",
    "sublabel": "The Criminal Case Reporting System is a web-based case management and forms application system for the entry, retrieval, and processing of criminal docket case information for the Office of Criminal Enforcement, Forensics and Training.  It is being modernized with an expected go live date of around October 1st, 2019. The new system is being called the Online Criminal Enforcement Activities Network (OCEAN).",
    "value": "020-000016020"
  },
  {
    "label": "CDX - Central Data Exchange",
    "sublabel": "CDX is the established electronic gateway for environmental data entering the Agency and serves as EPA's Node on the Environmental Information Exchange Network.",
    "value": "020-000016005"
  },
  {
    "label": "CEDRI - Compliance and Emissions Data Reporting Interface",
    "sublabel": "Located on EPA's Central Data Exchange (CDX), the Compliance and Emissions Data Reporting Interface (CEDRI) is a program service supporting the submittal of Performance Test Reports, Notification Reports, Periodic Reports and Information Collection Requests.",
    "value": "020-000000074"
  },
  {
    "label": "CIMC - Cleanups In My Community",
    "sublabel": "The system is a web application that enables integrated access through maps, lists and a search capability to site-specific information EPA has across all cleanup programs.  Maps show the sites in context with related data - both EPA and non-EPA.  CIMC Web Services provide data for others to use.  OLEM offices and regions leverage CIMC for web page maps, listings, merging data with GeoDatabases, and building site-specific Drupal pages.",
    "value": "020-000013016"
  },
  {
    "label": "CLPSS - Contract Laboratory Program Support System",
    "sublabel": "CLPSS provides the means to individually identify, track, monitor, and oversee the quality of each analysis performed on Superfund samples from the point of collection through final data reporting and payment.",
    "value": "020-000000040"
  },
  {
    "label": "CMS- Correspondence Management System",
    "sublabel": "CMS is EPA's correspondence tracking and workflow management system. It scans, logs, routes, tracks, and stores incoming and outgoing correspondence in all Program and Regional Offices.",
    "value": "020-000016048"
  },
  {
    "label": "CRWUF-Climate Ready Water Utilities Framework",
    "sublabel": "The Climate Ready Water Utilities Framework (CRWUF) developed under EPA s Climate Ready Water Utilities initiative, assists drinking water, wastewater, and storm water utility owners and operators in assessing risks to utility assets and operations.",
    "value": "020-000000034"
  },
  {
    "label": "CWNS - Clean Watersheds Needs Survey",
    "sublabel": "Stores information about Publicly Owned Treatment Works (POTWs), Storm Water (SW) management programs, and Nonpoint Source (NPS) pollution control programs and projects that are eligible for funding under Clean Water State Revolving Funds.",
    "value": "020-000012050"
  },
  {
    "label": "Capital Planning and Investment Control",
    "sublabel": "Supports Capital Planning and Investment Control implementation, other Clinger-Cohen Act implementation activities.",
    "value": "020-000030302"
  },
  {
    "label": "ChemView",
    "sublabel": "ChemView provides a single access point for select TSCA chemical data and OPPT's primary access point for providing information on TSCA chemicals to industry and the general public. Streamlining search efforts providing user detailed information about chemicals.",
    "value": "020-000014020"
  },
  {
    "label": "Chemical Information System - New Chemical Review  (CIS-NCR)",
    "sublabel": "Data system to receive, store, process and report out information reported by industry as required under the Toxic Substance Control Act (TSCA).",
    "value": "020-000000041"
  },
  {
    "label": "Chemical Safety Mission Investment",
    "sublabel": "Collection of IT Investments less than $250K per year supporting EPA's National Chemical Safety and Pollution  Program. These resources are continuously reviewed and updated as part of the effort to increase transparency for the organization.",
    "value": "020-000000089"
  },
  {
    "label": "DARS - Data Analysis and Review System",
    "sublabel": "The Data Analysis and Review System (DARS) is a suite of tools for analyzing and reviewing emissions data submitted under 40 CFR Part 75 - Continuous Emission Monitoring.",
    "value": "020-000000046"
  },
  {
    "label": "DMAP - Data Management and Analytical Platform",
    "sublabel": "The Data Management and Analytics Platform (DMAP) will enable the Office of Mission Support - Environmental Information (OMS-EI) to offer a shared services platform of scalable data hosting and analytics tools leveraging the cloud for enterprise-wide data access, data visualization, geospatial, and analytical capabilities across EPA, both public-facing and internal. DMAP is a Cloud-hosted data management, analytics, and machine learning platform with big data capabilities to support data and scientific projects across the agency. DMAP includes a searchable, shared Data Commons providing data storage in a well-governed format that is ready to use in analytics, data visualization, and other platforms. DMAP also includes data and model hosting via Amazon Web Services geared toward containerization, serverless compute, and Internet of Things (IoT) capabilities.",
    "value": "020-100000050"
  },
  {
    "label": "DS-Discovery Services",
    "sublabel": "Discovery Services comprises the strategies and tools to search, collect and process Agency electronically stored information (ESI) in response to litigation, FOIA , congressional inquiries and other official document production requests.",
    "value": "020-000000033"
  },
  {
    "label": "DWINS- Drinking Water Infrastructure Needs Survey",
    "sublabel": "DWINS is a database used to house and analyze responses from the quadrennial Drinking Water Infrastructure Needs Survey mandated by the Safe Drinking Water Act. The data are used to develop the formula for allocating grants to public water systems.",
    "value": "020-000012022"
  },
  {
    "label": "E-Enterprise Portal",
    "sublabel": "The E-Enterprise Portal was piloted to provide a consolidated entry point for regulated entities and citizens to efficiently locate, obtain access to, and interact with relevant EPA, State and Tribal environmental services. In 2018, it was merged into EPA's Central Data Exchange (CDX) infrastructure. In 2020, the decision was made to stop development on the portal and retire the investment the end of December 2020.",
    "value": "020-000016050"
  },
  {
    "label": "E-Gov: FOIA Portal",
    "sublabel": "FOIA Portal is a new E-Gov initiative managed by DOJ as part of FOIA Improvement Act. The Portal provides a doorway for the public to submit FOIA requests to all agencies. IT Project Code FH E1).",
    "value": "020-000000059"
  },
  {
    "label": "E-Gov: Federal PKI Bridge",
    "sublabel": "PKI fee to connect PIV cards for both physical access and networks.",
    "value": "020-000000049"
  },
  {
    "label": "E-Gov: Grants.gov",
    "sublabel": "Cost of integrating investment to Grants.gov Find and Apply.",
    "value": "020-999990160"
  },
  {
    "label": "E-Gov: Integrated Award Environment",
    "sublabel": "Former IAE-Loans & Grants. Agency contribution.",
    "value": "020-999990230"
  },
  {
    "label": "E-Gov: USAJOBS",
    "sublabel": "Current Recruitment One-Stop partner agency contribution.",
    "value": "020-999991218"
  },
  {
    "label": "E-Gov: e-Rulemaking Partner Contribution",
    "sublabel": "Partner Agency Contribution for the eRulemaking eGov shared service managed by GSA.",
    "value": "020-000000081"
  },
  {
    "label": "EAMS - EPA Action Management System",
    "sublabel": "The Office of Policy manages the EPA's core regulatory function. This new investment will modernize the Agency's major regulatory tracking and reporting functions to streamline data entry and to simplify data extraction for reporting.",
    "value": "020-000016100"
  },
  {
    "label": "EAS - EPAs Acquisition System",
    "sublabel": "EPA's Acquisition System (EAS) is used for all large and small contract actions from Requisition to Close for the agency. Funding will provide necessary licensing and maintenance for continued use of  the application and critical customer support.",
    "value": "020-000016231"
  },
  {
    "label": "EASEY - Emissions and Allowance System for Energy",
    "sublabel": "OAP is working to replace its Clean Air Markets Division Business Systems (CAMDBS) to ensure the system can continue to support administration of market-based cap-and-trade programs. CAMDBS and the Data Analysis and Review System (DARS), including the Field Audit Checklist Tool (FACT), will continue to operate until they can be replaced by EASEY and EASEY will be tracked as a separate CPIC system. This rebuild will take advantage of New technologies, such as cloud technology, API, and modular building of applications. It will replace all the business requirements in the current CAMDBS system.",
    "value": "020-100000056"
  },
  {
    "label": "ECHO - Enforcement and Compliance History Online",
    "sublabel": "The Enforcement and Compliance History Online data marts and webpages provide cross-media (air, water and waste) integrated view of EPA regulated facilities from Agency enforcement databases for Federal and State employees and the public.",
    "value": "020-000015060"
  },
  {
    "label": "ECMS - Enterprise Content Management Service",
    "sublabel": "ECMS comprises the strategies and tools to collect, maintain, preserve, search, retrieve, access and process Agency records and information resources.",
    "value": "020-000016240"
  },
  {
    "label": "ECSS - Enterprise Customer Service Solution",
    "sublabel": "The Enterprise Customer Service Solution-Frequently Asked Questions utilizes Commercial Off-The-Shelf software to offer Agency program offices an opportunity to automate and standardize responses to comments and queries received from various channels (i.e., Web or hotlines) through the use of a common knowledge database and response templates. This contract & investment will end on 30 September 2020.",
    "value": "020-000000073"
  },
  {
    "label": "EDG - Environmental Data Gateway",
    "sublabel": "EDG provides EPA staff and the public with a central location for discovering, accessing and managing metadata records describing the Agency's geospatial and non-geospatial datasets and ensures that these metadata records are displayed at Data.gov.",
    "value": "020-000016010"
  },
  {
    "label": "EIS- Emission Inventory System",
    "sublabel": "EIS is the sole national-level repository for data about sources that emit criteria air pollutants and their precursors, and hazardous air pollutants.",
    "value": "020-000011077"
  },
  {
    "label": "EMP- Emergency Management Portal",
    "sublabel": "The EMP is the gateway tool to three application modules:  Field Readiness and Oil Database.  As well as four software tools EMP-Admin, EMBI, Incident  Management Handbook, and Document Library.",
    "value": "020-000013013"
  },
  {
    "label": "ENERGY STAR IT/IM System",
    "sublabel": "This investment comprises three core IT/IM platforms that support EPA's ENERGY STAR program.  ENERGY STAR is the government-backed symbol for energy efficiency, providing simple, credible, and unbiased information that consumers and businesses rely on to make well-informed decisions. Thousands of industrial, commercial, utility, state, and local organizations partner with the EPA to deliver cost-saving energy efficiency solutions that improve air quality and protect the climate. Specifically, this investment represents ENERGY STAR's IT infrastructure, ENERGY STAR's Partner Resources platform (called ES Connect) for managing partnership information, and ENERGY STAR's Portfolio Manager - an interactive resource management tool for assessing energy, water, and waste use in commercial buildings.",
    "value": "020-000000099"
  },
  {
    "label": "EPA Data Center Standard Investment",
    "sublabel": "EPAs Data Center and Cloud Standard investment includes the technologies and infrastructure that support and enable the development, deployment, hosting, execution and use of Agency databases and software applications..",
    "value": "020-000000067"
  },
  {
    "label": "EPA End User Standard Investment",
    "sublabel": "EPA's End User Investment includes end user computing devices and support for end users. The scope includes costs to build, manage and run end user computing devices for the enterprise and deliver centralized support to end users.",
    "value": "020-000000066"
  },
  {
    "label": "EPA Enterprise Architecture Development and Implementation",
    "sublabel": "Develop and run the EPA Enterprise Architecture program.",
    "value": "020-000030301"
  },
  {
    "label": "EPA HQ Geospatial Support Investment",
    "sublabel": "This investment includes Information Technology assets and resources within the EPA Headquarters National Program Management (NPM) Offices, including geospatial hardware, software and services, Federal Full-Time Equivalents (FTEs) that perform IT functions in support of their NPM, Contractor resources, and contributions to the Agency-wide mandatory EG Geospatial  Service through the Working Capital Fund (WCF). This is a consolidated business case that captures many individual investments and support functions for each HQ NPM.",
    "value": "020-100000054"
  },
  {
    "label": "EPA Network Standard Investment",
    "sublabel": "The EPA Network Standard Investment provisions the backbone connectivity and transport infrastructure delivering voice and data services to over 100 EPA physical locations nationwide.  These network services are fundamental to Agency mission accomplishment by enabling communications, collaboration, and partnerships among internal EPA staff; state, local, and tribal governments; regulated entities; communities; and, the public for the establishment of environmental policies, enforcement of Federal laws, and environmental education.",
    "value": "020-000000065"
  },
  {
    "label": "EPA Regional Geospatial Support Investment",
    "sublabel": "This investment includes Information Technology assets and resources within the EPA Regional Offices, including geospatial hardware, software and services, Federal Full-Time Equivalents (FTEs) that perform IT functions in support of their Region, Contractor resources, and contributions to the Agency-wide mandatory EG Geospatial Service through the Working Capital Fund (WCF). This is a consolidated business case that captures many individual investments and support functions for each Region.",
    "value": "020-100000055"
  },
  {
    "label": "ERTFOS - Environmental Response Team Field Operations Systems",
    "sublabel": "Collection of field data management systems ranging from sampling, lab analytical, project management, and sensor data. System also encompasses several web platforms for GIS visualization and operational data hosting. This is a new investment that captures multiple small and other investments all in the same mission area.",
    "value": "020-000000101"
  },
  {
    "label": "EV-CIS-Engines and Vehicles Compliance Information System",
    "sublabel": "The Engines and Vehicles Compliance Information System (EV-CIS) is a consolidated web database application system that supports emissions, fuel economy, and greenhouse gas compliance activities for mobile sources per Title 40 of the Code of Federal Regulations (CFR).",
    "value": "020-000000028"
  },
  {
    "label": "e-Manifest",
    "sublabel": "e-Manifest is a mandated electronic option for users of EPA's current paper manifest (EPA Form 8700-22 and 8700-22a) to track RCRA hazardous waste shipments, to be built & operated by an EPA contractor paid from future user fees, as authorized by Congress.",
    "value": "020-000013014"
  },
  {
    "label": "Enforcement & Compliance Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's Compliance and Enforcement Program.",
    "value": "020-000000091"
  },
  {
    "label": "eNOI- Electronic Notice of Intent Database",
    "sublabel": "The eNOI system is an online electronic permit application system that allows permittees to apply for coverage and submit reports under EPA's NPDES Pesticide General Permit (PGP).",
    "value": "020-000012024"
  },
  {
    "label": "Enterprise Human Resource Systems",
    "sublabel": "EPAs  investment in enterprise-wide IT systems and services supporting Human Resources.",
    "value": "020-999991200"
  },
  {
    "label": "Envirofacts - Envirofacts Information Warehouse",
    "sublabel": "Envirofacts Information Warehouse provides the public with a textual and geographic interface into Envirofacts data. Envirofacts includes information from a variety of EPA programs, including air, water, superfund, and hazardous waste.",
    "value": "020-000016003"
  },
  {
    "label": "ePACS - HSPD-12 Enterprise Physical Access Control System",
    "sublabel": "HSPD-12 Enterprise PACS infrastructure modernization.",
    "value": "020-000000062"
  },
  {
    "label": "e-Payroll Service Fee",
    "sublabel": "E-Payroll service fee.",
    "value": "020-999991221"
  },
  {
    "label": "FLPP - Federal Lead-Based Paint Program",
    "sublabel": "Process and tracks applications for lead certifications and accreditation for the Federal Lead-Based Paint Program.",
    "value": "020-000014003"
  },
  {
    "label": "FOIAonline",
    "sublabel": "FOIAonline is a multi-agency web-application that enables the public to submit FOIA requests to participating agencies, track the progress of an agency's response to a request, search for information previously made available, and generate up-to-the-minute reports on FOIA processing. FOIAonline also is a multi-agency workflow system and repository that enables partner agencies to receive, manage, track, and respond to FOIA requests, generate reports including the annual FOIA report that is submitted to the Department of Justice, communicate with requesters, and manage their FOIA case files as electronic records.",
    "value": "020-000016002"
  },
  {
    "label": "FOLIO",
    "sublabel": "FOLIO is a web-based application owned and hosted by GSA and used by 17 federal agencies for IT Capital Planning, Portfolio Management, and external reporting processes. Through an Inter-Agency Agreement with GSA, EPA uses this application to control and evaluate investment projects for reporting to OMB IT Dashboard, conduct oversight of IT Investments, prepare and submit Investment Information to OMB. eCPIC has over 150 users with various roles. Managing Partner UII:023-999993310.",
    "value": "020-000000068"
  },
  {
    "label": "FRS - Facilities Registration System",
    "sublabel": "The Facility Registry System (FRS) is a centrally managed database that identifies facilities either subject to environmental regulations or of environmental interest, providing an integrated source of air, water, and waste environmental data.",
    "value": "020-000016030"
  },
  {
    "label": "Factotum",
    "sublabel": "Scientific data management system for chemical exposure data streams. Application allows for the storage, management, curation and QA of publicly available chemical exposure data streams including product composition, chemical functional use, broad chemical use, multimedia measurement and monitoring data, etc. Application allows for feeding data to external facing public dashboards (e.g. CompTox Chemistry Dashboard) and to prioritization/pre-prioritization and similar workflow processes.",
    "value": "020-000000082"
  },
  {
    "label": "Federal Human Resources Management LoB",
    "sublabel": "This investment is for the annual mandatory eGov payment funding transfer.",
    "value": "020-999991201"
  },
  {
    "label": "FinRS - Financial Replacement System",
    "sublabel": "EPA's mission is \"\"to protect human health and the environment.\"\" To accomplish this mission, EPA relies on core financial management functions such as budget execution, accounting, payments and collections, financial statements, and financial accountability reports. The Financial Replacement Systems (FinRS) investment is the EPA Office of the Chief Financial Officer's (OCFO) on-going maintenance of the agency's core financial system which supports the EPA s most critical business needs.  The core components include Compass and other associated tools that are used to meet the following business needs: General Ledger, Accounts Payable, Accounts Receivable, Project Cost, Intra-Governmental Transactions, Budget Execution and Financial Reporting.",
    "value": "020-000010126"
  },
  {
    "label": "Fleet Access",
    "sublabel": "General Services Administration FMR B-15 requires each federal agency to store and maintain vehicle asset data collected in a fleet management information system (FMIS). EPA uses the Fleet Access COTS system for compliance with this mandate. This system stores vehicle level data such as license plate, VIN, make, model, acquisition value/and or lease rates as well as designations regarding alternative fuel, energy, and sustainability mandates.",
    "value": "020-000000102"
  },
  {
    "label": "Fuel Reporting System (TERRA)",
    "sublabel": "TeRRA is the EPA Fuel program compliance and reporting system.  An abbreviation from Transaction, eBusiness, Registration, Reporting, Analytics. It consolidates all the Fuels program systems such as OTAQReg, DCFuels, EMTS, DART, Maillog, RP79, etc. TeRRA has compliance data related to gasoline, diesel, renewables, and other fuels and fuel additives.  These data are collected from refiners, importers, independent laboratories, and fuel and fuel additive manufacturers. This system is critical for EPA compliance work.",
    "value": "020-000011066"
  },
  {
    "label": "GHGMRR- Greenhouse Gas Mandatory Reporting Rule",
    "sublabel": "The GHGMRR Data System (electronic Greenhouse Gas Reporting Tool or e-GGRT) supports the annual reporting and verification of greenhouse gas and emissions data to the EPA by over 8,000 regulated facilities under (Clean Air Act) 40 CFR Part 98, \"Mandatory Reporting of Greenhouse Gases Rule\" originally funded by the FY08 Omnibus Appropriations, Dec 26, 2007.",
    "value": "020-000011082"
  },
  {
    "label": "General Counsel Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's Office of General Counsel.",
    "value": "020-000000096"
  },
  {
    "label": "GeoPlatform",
    "sublabel": "The EPA Geospatial Platform is a shared service that provides users with a comprehensive set of cloud-based Geographic Information System (GIS) services that enable them to easily create web-based maps, perform environmental analyses, and share their work using online tools.",
    "value": "020-000016122"
  },
  {
    "label": "HERO - Health and Environmental Research Online",
    "sublabel": "Health and Environmental Research Online (HERO) is a database of scientific studies and other references used to develop EPA's risk assessments aimed at understanding the health and environmental effects of pollutants and chemicals.  To satisfy the requirements of the Clean Air Act, Clean Water Act, and other regulatory processes that protect human health and the environment, EPA is tasked with creating scientific assessments of chemicals and other pollutants. These assessments are used as the scientific basis for setting EPA standards. To create these assessments, EPA scientists need to collect, evaluate, and synthesize thousands of scientific publications on a continuing basis. HERO gathers data from scientific publications in a systematic manner, categorizes and evaluates these publications, and provides on-line accessibility for EPA assessment scientists and stakeholders.",
    "value": "020-000016049"
  },
  {
    "label": "ICIS - Integrated Compliance Information System",
    "sublabel": "The purpose of ICIS is to meet evolving Enforcement and Compliance business needs for EPA and State users by integrating information into a single integrated data system that supports both management and programmatic requirements of the Enforcement and Compliance programs.  As technology and compliance assurance needs have evolved, EPA recognizes the need to modernize its major investments which will lead to flexibility, eventual reduction in operating costs, and ability to leverage services across the enterprise.  The first step in the modernization effort will be engaging states, regions, EPA programs, other regulated entities to flush out a Concept of Operations.   In FY2021, the ICIS Modernization effort will continue the Concept of Operations (CONOPS) which will define the compliance assurance business workflow.  The CONOPS will inform the implementation of required business functions, the physical infrastructure needs, and policies. The objective will be to include EPA program.",
    "value": "020-000015010"
  },
  {
    "label": "ICRAS Information Collection Review and Approval System",
    "sublabel": "ICRAS allows the Agency to develop, review, and track Information Collection Requests and submit them to OMB as required by the Paperwork Reduction Act (PRA).",
    "value": "020-100000032"
  },
  {
    "label": "IGEMS - Inspector General Enterprise Management System",
    "sublabel": "The Inspector General Enterprise Management System (IGEMS) is a GOTS integrated enterprise tool that provide audit, program evaluation and investigations information tracking, project and cost tracking to support OIG's mission.   IGEMS continues to enhance existing modules and build new ones to support business needs.",
    "value": "020-000016039"
  },
  {
    "label": "IGMS - Integrated Grants Management System",
    "sublabel": "The Integrated Grants Management System (IGMS) is EPA's grants management system until the Agency migrates to the Next Generation Grants System (NGGS). The IGMS legacy system supports all phases of the grants management lifecycle from opportunity announcement to closeout. IGMS also supports the Agency's interagency agreements until the EPA migrates to the USDT's G-Invoicing solution.",
    "value": "020-000041306"
  },
  {
    "label": "Inspector General Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's Office of  Inspector General.",
    "value": "020-000000097"
  },
  {
    "label": "International & Tribal Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's International and Tribal Affairs Program.",
    "value": "020-000000098"
  },
  {
    "label": "LDMS - NVFEL Laboratory Data Management System",
    "sublabel": "The LDMS provides data collection, transfer, and processing systems for all laboratory testing operations at the National Vehicle and Fuel Emissions Laboratory, in support of the EPA's mission to ensure clean air with regard to the transportation sector.  This consists of multiple software systems in support of vehicle, engine, and fuels emissions testing at NVFEL.",
    "value": "020-000011063"
  },
  {
    "label": "Land and Emergency Management Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's National Land and Emergency Management Program.",
    "value": "020-000000090"
  },
  {
    "label": "LoB: Budget Formulation and Execution",
    "sublabel": "Partner Agency.",
    "value": "020-999993200"
  },
  {
    "label": "LoB: Financial Management",
    "sublabel": "Financial Management Line of Business Partner Contribution. Former GMLoB.",
    "value": "020-999991100"
  },
  {
    "label": "LoB: Geospatial",
    "sublabel": "Contributing Partner.",
    "value": "020-999990120"
  },
  {
    "label": "MOVES - Motor Vehicle Emissions Simulator",
    "sublabel": "EPA's MOtor Vehicle Emission Simulator (MOVES) is an emission modeling system that estimates emissions for mobile sources (cars, trucks, etc.) at the national, county, and project level for criteria air pollutants, greenhouse gases, and air toxics.  It is used by EPA, states, local governments and others.",
    "value": "020-000011062"
  },
  {
    "label": "Mission Support Investment",
    "sublabel": "This investment comprises IT systems and applications each less than $250K/year each that support Agency-wide Information Technology/Information Management (IT/IM) and Administrative Service functions. Per approval of the EPA CIO and OMS SIO, this investment is classified as a Non-Major Investment.",
    "value": "020-000000088"
  },
  {
    "label": "Multi-Media Enterprise Architecture",
    "sublabel": "Supports EA efforts in the Offices of: Air and Radiation, Enforcement, Inspector General, Pesticides and Toxic Substances, Research and Development, Land and Emergency Management, and Water.",
    "value": "020-000030303"
  },
  {
    "label": "NARSIMS-National Aquatic Resource Survey Information Management System",
    "sublabel": "The U.S. EPA, states, and tribes are conducting a series of national aquatic resource surveys. Often referred to as probability-based surveys, these studies report on core indicators of water condition using standardized field and lab methods.",
    "value": "020-000000035"
  },
  {
    "label": "NAUM - National Advanced Utility Metering",
    "sublabel": "The National Advanced Utility Metering (NAUM) system is used to monitor utility consumption of EPA managed facilities required by the Energy Policy Act of 2005 (EPAct 2005), the Energy Independence and Security Act of 2007 (EISA 2007) and Executive Order 13514, along with other Presidential Memorandums that have established the need for additional water and utility metering.",
    "value": "020-100000052"
  },
  {
    "label": "NGGS - Next Generation Grants System",
    "sublabel": "This purpose of this investment is to build upon the legacy IGMS pre-award module and to plan, develop, test, implement, and maintain the IGMS Next Generation system, which is to be the successor to the legacy IGMS system.  Like IGMS, the IGMS Next Generation system will include pre-award, award, and post-award modules and will serve Agency-wide grants management business and operational needs, including grant application, pre-award, award, post-award, and close-out activities.",
    "value": "020-000000038"
  },
  {
    "label": "OAR Internet Support",
    "sublabel": "Website development/maintenance for the air program within EPA to provide stakeholder and public access to rules, regulations, and other technical information.",
    "value": "020-000011073"
  },
  {
    "label": "OARM Data Mart",
    "sublabel": "The OMS Data Mart project is designed to provide EPA staff and managers with tools for fast and efficient access to data currently stored in OMS systems.  Data from various OMS source systems will be extracted, transformed, and loaded.",
    "value": "020-000016025"
  },
  {
    "label": "OASIS - Office of Administration Services Information System",
    "sublabel": "OASIS is a centralized web-based gateway to core support services, information, and applications. Access is limited to EPA Government employees and authorized contractor employees only.",
    "value": "020-000016023"
  },
  {
    "label": "OCEAN - Online Criminal Enforcement Activities Network",
    "sublabel": "OCEAN is a web-based case management and forms application system for the entry, retrieval, and processing of criminal docket case information.  It replaced CCRS  Criminal Case Reporting System.",
    "value": "020-100000049"
  },
  {
    "label": "OCFO GSS - Office of the Chief Financial Officer General Support System",
    "sublabel": "The OCFO General Support System (GSS) is comprised of several applications/systems that provide support functions for OCFO. These applications enable the development/testing environment used for baselining and benchmarking applications, testing applications, and supporting a production environment for hosting data.  The OCFO GSS production environment also provides the core infrastructure (hardware, operating systems, databases, and Commercial Off-the-Shelf (COTS) infrastructure).  Examples of GSS applications include SharePoint Project Management application (PWA), the ULO application, and the Serena Business Manager (SBM) application.",
    "value": "020-000000083"
  },
  {
    "label": "OMIS - ORD Management Information System",
    "sublabel": "OMIS is an integrated set of applications designed to help ORD improve its management of financial and administrative information.",
    "value": "020-000016004"
  },
  {
    "label": "OPPT Information Management System",
    "sublabel": "Building on the existing shelf program Salesforce , this investment provides functionality for program and project management, level of effort and resource management management document repository and support in OPPT.",
    "value": "020-000000042"
  },
  {
    "label": "P2RMIS - Program and Peer Review Management and Information System",
    "sublabel": "P2RIMS System is a virtual online peer review system that assists in the evaluation and management of applications and proposals that are submitted to the EPA, Office of Research and Development (ORD), Office of Science Advisor, Policy & Engagement (OSAPE) as part of a competitive peer review process.",
    "value": "020-000000105"
  },
  {
    "label": "PAT- Performance Assessment Tool",
    "sublabel": "OLEM PAT is a performance measures dashboard and reporting mechanism. It automates the process of reporting on performance measures and makes the measures data more accessible for management and analysis in OLEM.",
    "value": "020-000013017"
  },
  {
    "label": "PMS - Payment Management System",
    "sublabel": "EPA's Payment Management Systems support workflow activities that enable payments in EPA's Core financial system and efficiently distribute expenses to support financial accounting and reporting.",
    "value": "020-000001140"
  },
  {
    "label": "PRISM - Pesticide Registration Information System",
    "sublabel": "PRISM provides e-government capabilities to share pesticide information with OPP stakeholders. PRISM will also support OPP's responsibilities under Registration Review and the Pesticide Registration Improvement Renewal Act (PRIA4). All delivery methodologies will follow Agile iterative principles.",
    "value": "020-000014030"
  },
  {
    "label": "PSS - Personnel Security System 2.0",
    "sublabel": "The PSS 2.0 supports the mission function to conduct personnel security and suitability determinations for compliance with federal directives using a flexible COTS application accelerator for the case management workflow designed to ensure that candidates are properly vetted as suitable for EPA employment. The PSS 2.0 project modernizes and replaces the legacy PSS 1.0 system.",
    "value": "020-000000084"
  },
  {
    "label": "QAEMS - Quality Assurance Enterprise Management System",
    "sublabel": "The Quality Assurance Enterprise application is an agency-wide system being designed to record, track and share quality assurance (QA) documentation and reports for the Agency. Examples include: Quality Management Plans (QMP), QA Project Plans (QAPP) and SOPs. QAEMS is designed to simplify the QA annual reporting process.",
    "value": "020-000000051"
  },
  {
    "label": "RCRAInfo- Resource Conservation and Recovery Act Information",
    "sublabel": "RCRAInfo provides access to data supporting the Resource Conservation and Recovery Act (RCRA) of 1976 and Hazardous and Solid Waste Amendments of 1984.  (This system manages the national hazardous waste program information).",
    "value": "020-000013060"
  },
  {
    "label": "RDMS - Research & Development Mission Systems",
    "sublabel": "This investment represents the procurement and use of research and development specific commercial-off-the-shelf software and technologies that cost less than $250K each.  This software directly supports science activities in the following research areas:  Sustainable and Healthy Communities, Chemical Safety for Sustainability, Homeland Security, Health and Environmental Risk Assessment, Air and Energy, and Safe and Sustainable Water Resources.",
    "value": "020-100000053"
  },
  {
    "label": "RSDCI -  Research Science Data Center",
    "sublabel": "RSDCI provides servers and network file storage in support of the unique requirements of ORD's scientific research mission which are not available from other EPA's infrastructure investments.",
    "value": "020-000000075"
  },
  {
    "label": "RSNI - Research Science Network Standard Investment",
    "sublabel": "RSNI is an on-going investment provided to ORD's remote Research Laboratories to support  local network and voice communications. It includes  support for network security, VoIP, hands-on support for networking and phone equipment, operation and management of local network equipment, support for local wiring installation, support for wireless communications, and local network port configuration and management.  No other EPA support provides these services at these remote labs.",
    "value": "020-000000078"
  },
  {
    "label": "RSSDI - Research Science Service Desk Investment",
    "sublabel": "RSSDI is an ongoing investment which provides remote and desk-side support services to enable ORD's scientific research mission.",
    "value": "020-000000077"
  },
  {
    "label": "RSSI - Research Science IT Security Standard Investment",
    "sublabel": "RSSI is an ongoing investment which provides IT security support to enable and protect ORD's scientific research information and systems.",
    "value": "020-000000076"
  },
  {
    "label": "Research & Development Mission Investment",
    "sublabel": "This investment is a subset of the Agency Small and Other Systems-project code (SM) specific to the Office of Research and Development. This ongoing investment includes the development and maintenance of small research and development systems as well as the systems that are used to manage the Agency's research and development efforts. Modeling activities-scientific, statistical, or other-web content development or management, library services, and scientific equipment are not considered to be IT and are excluded from this investment.  Systems contained in this investment are developed specifically for the Office of Research and Development and support the following research areas_ Sustainable and Healthy Communities, Chemical Safety for Sustainability, Homeland Security, Health and Environmental Risk Assessment, Air and Energy and Safe and Sustainable Water Resources.",
    "value": "020-000000093"
  },
  {
    "label": "Research Approval Planning Implementation Dashboard (RAPID)",
    "sublabel": "RAPID (Research Approval Planning Implementation Dashboard) enables researchers to manage the entire research process via one user interface, eliminating the need to learn multiple systems.",
    "value": "020-100000048"
  },
  {
    "label": "SDWIS - Safe Drinking Water Information System Modernization",
    "sublabel": "The Safe Drinking Water Information System (SDWIS) Modernization is a legacy modernization project. This investment currently includes development, operations, and maintenance of the Compliance Monitoring Data Portal (CMDP) and SDWIS Modernization efforts, intended to replace the current suite of SDWIS software distributed by the EPA to Primacy Agencies in support of implementing the Public Water System Supervision Program established under the Safe Drinking Water Act of 1974 (Public Law 93-523) and the 1996 Amendments to the Act.",
    "value": "020-000012031"
  },
  {
    "label": "SEMS - Superfund Enterprise Management System",
    "sublabel": "SEMS is EPAs official recordkeeping system for tracking all hazardous waste site assessment and remediation activities performed in support of Superfund (Comprehensive Environmental Response, Compensation and Liability Act 1986 (CERCLA) as amended).",
    "value": "020-000013015"
  },
  {
    "label": "SI - Superfund Imaging",
    "sublabel": "The Superfund Imaging system, also known as the Superfund Cost Recovery Package and Image On-Line System (SCORPIOS), produces the documentation used to recover the cost of cleaning up hazardous waste from potentially responsible parties (PRPs).  This system is being replaced with eRecovery.",
    "value": "020-000001130"
  },
  {
    "label": "SRMP- System for Risk Management Plans",
    "sublabel": "SRMP provides risk management information about chemical facilities with regulated quantities of extremely hazardous substances. SRMP is an electronic reporting and access tool that reduces regulatory reporting burdens.",
    "value": "020-000013030"
  },
  {
    "label": "STICS - Scientific & Technical Information Clearance System",
    "sublabel": "STICS is an electronic clearance system developed to automate the paper-based review and approval process for clearing ORD scientific and technical products. Instead of filling out a paper form, information is entered into STICS after a product's technical reviews are complete.",
    "value": "020-100000051"
  },
  {
    "label": "ScienceHub",
    "sublabel": "ScienceHub provides researchers with a way to track information, research plans, and data related to their research efforts. ScienceHub  complies with the OMB Open Data Policy by readying research data for public access.",
    "value": "020-000000023"
  },
  {
    "label": "Small/Other:  Cooperative Federalism",
    "sublabel": "IT investments less than $250K per year supporting EPA's Cooperative Federalism Goal.",
    "value": "020-000000057"
  },
  {
    "label": "Small/Other:  Core Mission",
    "sublabel": "IT investments less than $250K per year supporting EPA's Core Mission Goal.  Consists of investments from OCSPP, OAR, OLEM, OW, OEI, ORD.",
    "value": "020-000000056"
  },
  {
    "label": "Small/Other:  Rule of Law",
    "sublabel": "IT investments less than $250K per year supporting EPA's Rule of Law Goal.",
    "value": "020-000000058"
  },
  {
    "label": "Smart Mobile Tools for Field Inspectors (Smart Tools)",
    "sublabel": "This Investment brings environmental inspections into the 21st century by supporting planning and management, field data collection, and evidence management all within an integrated suite of digital tools to improve the quality and consistency.",
    "value": "020-000000037"
  },
  {
    "label": "SoR - System of Registries",
    "sublabel": "The System of Registries are enterprise shared data services that manage and provision data centrally for use by EPA and state systems. Shared data services reduce burden for EPA systems by not having to manage this information themselves, as well as promoting data quality and reducing burden by the reporting community.",
    "value": "020-000016006"
  },
  {
    "label": "TAP - Time & Attendance and Payroll",
    "sublabel": "Time & Attendance and Payroll is the agency's PeoplePlus Implementation of Time & Attendance along with the supporting payroll activities, which include: Shared Service Provider DOI/IBC Payroll and the Momentum Payroll Cost Allocation Module.The Time & Attendance system supports 15,681 active users. The Time & Attendance System was upgraded from 8.9 to 9.2 removing many EPA unique customizations and pulling the financial activity of payroll cost allocation out of People Plus and into the core financial system under the Payroll Cost Allocation Module.",
    "value": "020-000000069"
  },
  {
    "label": "TRI AN - TRI Analyzer (Front End)",
    "sublabel": "This is a web enabled tool that replicates and expands on functionality of the TRI.NET desktop application. (TRI.Net to be retired). The tool offers easy access to EPA Toxic Release Inventory (TRI) data and ability to perform detailed analytics.",
    "value": "020-000014078"
  },
  {
    "label": "TRI-MEweb - Toxics Release Inventory-Made Easy Web",
    "sublabel": "TRI-MEweb is a web-based application that allows facilities to use EPA's Central Data Exchange to report annual toxic chemical release data as required by Section 313 of the Emergency Planning and Community Right-to-Know Act (EPCRA).",
    "value": "020-000014079"
  },
  {
    "label": "TRIPS - Toxics Release Inventory Processing System",
    "sublabel": "TRIPS facilitates the collection and preparation for dissemination of Toxics Release Inventory data and is functionally defined by two Acts: the Emergency Planning and Community Right-to-Know Act of 1986 and the Pollution Prevention Act of 1990.",
    "value": "020-000014081"
  },
  {
    "label": "TSEC - TIGER Security",
    "sublabel": "TSEC is an independent OIG virtual private solution with related storage technology to better secure operations; provide end to end encryption; and consolidate all OIG applications to ensure protection of sensitive information.",
    "value": "020-000016027"
  },
  {
    "label": "USAccess - PIV Card Program",
    "sublabel": "The PIV Card Program will utilize the USAccess Managed Service (UII 023-000004180) for PIV credential production, issuance, activation and management; adjudication, role holder administration and management reporting; and public key infrastructure (PKI) while maintaining the life cycle of the credentials for each employee.",
    "value": "020-000000063"
  },
  {
    "label": "WFGF - Water Financial and Grants Framework",
    "sublabel": "This investment combines the following systems into one investment, they are:  GRTS, OWSRF, WFC, and WIFIA Vault.",
    "value": "020-000000104"
  },
  {
    "label": "WQF - Water Quality Framework",
    "sublabel": "OW's Water Quality Framework is a cornerstone for the Office of Water's strategy to integrate data across OW and to make information available to EPA, state, and tribal water managers as well as public. The Framework contains information on water quality monitoring, state and tribal water quality assessments, plans for restoring and protecting water, and information related to EPA's progress in achieving strategic plan and budget goals surrounding water quality restoration and protection. To facilitate this integration, the Framework also contains connections to the underlying stream network that facilitates cross-program analyses. Lastly, in order to provide meaningful information to the public, the Framework connects all this information together to provide and easy-to-understanding communication tool which allows the public to explore water quality in their communities as well as understand the context of that water quality within their state or water quality nationwide.",
    "value": "020-000000103"
  },
  {
    "label": "Water Mission Investment",
    "sublabel": "IT Investments less than $250K per year supporting EPA's National Water Program.  This investment combines all OW small/other systems into one investment to include the following: ARS, SRC-CAT, CCR & IWriter, Check Up, GSDT, FWA, NEPR, NPDES-WP, NPDAT, NPSTBX, N-Steps, OWSWT, DWTS, SDWARs, WQSI, WSW and WAW.",
    "value": "020-000000087"
  },
  {
    "label": "Web Infrastructure Management of OneEPA Web",
    "sublabel": "The Web Infrastructure Management of OneEPA Web system goal is to provide accessible, relevant, timely, accurate and complete environmental information, and includes infrastructure, hosting, search, analytics and web content management system components necessary to support www.epa.gov and intranet.epa.gov.",
    "value": "020-000016009"
  },
  {
    "label": "WebEOC - Web Emergency Operations Center",
    "sublabel": "WebEOC is a web-based information management system providing real-time access to emergency information that can be simultaneously shared among emergency response teams, decision makers and supporting organizations during an emergency.",
    "value": "020-000014014"
  }
]